module.exports = __webpack_public_path__ + "media/24.858ceffd.mp3";